export default {
  title: {
    id: 'bo_seller_orders_tab_mobile_title',
    defaultMessage: 'Filters',
  },
} as const
